import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Week 8: What a girl who plays rugby can teach organizational leaders",
  "description": "",
  "published": "2013-12-09T00:00:00.000Z",
  "redirect_from": ["/blog/week-8-what-a-girl-who-plays-rugby-can-teach-organizational-leaders/swizec/6447"],
  "categories": "52papers52weeks, Canadians, Education, Learning, Personal, Sport, Sportsperson, Teacher",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`[`}{`This post is part of an ongoing challenge to understand 52 papers in 52 weeks. You can read previous entries, `}<a parentName="em" {...{
          "href": "http://swizec.com/blog/category/52-papers-in-52-weeks"
        }}>{`here`}</a>{`, or subscribe to be notified of new posts by `}<a parentName="em" {...{
          "href": "http://swiz.ec/52papers-list"
        }}>{`email`}</a>{`]`}</em></p>
    <p>{`Sometimes you read a paper and it fascinates you and challenges the way you think about things and inspires you to research a topic you never thought existed. This was not one of those papers.`}</p>
    <p>{`This was a paper about teaching key `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Value_%28personal_and_cultural%29",
        "title": "Value (personal and cultural)"
      }}>{`societal values`}</a>{` through sport and the notion that women are better at doing it than men. Written by Jennifer Wallinga, `}<a parentName="p" {...{
        "href": "https://docs.google.com/viewer?url=http%3A%2F%2Fwww.coach.ca%2Ffiles%2FCJWC_SEPT2012_EN.pdf"
      }}><em parentName="a">{`Teaching values through sport: A system perspective from women coaches`}</em></a>{` was a paper I helped my sister analyze for class.`}</p>
    <h2 {...{
      "id": "values-education-through-sport"
    }}>{`Values education through sport`}</h2>
    <p>{`The paper begins with a 15-year old girl who presented at some management conference about being a rugby player and what that's taught her about life in general. Particularly she said the scrum taught her about interdependence, that the idea of passing backward to make space to move forward is important and so on.`}</p>
    <p>{`But she wouldn't be able to articulate these points so well on her own. Her mother coached her specifically on transferring values and skills learned through sport into the rest of life.`}</p>
    <p>{`Wallinga points to a body of research showing that sport participation improves a person's well-being, teaches a lot of important values like team-work, dedication, camaraderie, trust and community building. Sport coaches and leaders are an integral part of these teachings as they help athletes recognise the life lessons they are learning.`}</p>
    <p>{`But due to professionalization sport has become too results obsessed and can at times even be detrimental to teaching key values. With too much inappropriate behaviour, cheating, and violence Canadians have plenty of sport, but maybe not the sport they want.`}</p>
    <p>{`Interestingly it seems that women coaches do a much better job of teaching their athletes key values than men coaches do. Likely a result of society bringing women up to be more others focused than men.`}</p>
    <h2 {...{
      "id": "systems-perspective-from-women-coaches"
    }}>{`Systems perspective from women coaches`}</h2>
    <p>{`Wallinga interviewed several women coaches about their approach to teaching athletes about key values. Doing so she explored four core themes:`}</p>
    <ul>
      <li parentName="ul">{`worldviews guiding their values frameworks`}</li>
      <li parentName="ul">{`values they teach through sport`}</li>
      <li parentName="ul">{`strategies for doing so`}</li>
      <li parentName="ul">{`transferring these learnings to life outside of sport`}</li>
    </ul>
    <p>{`Many coaches described the link between the commitment to sport and commitment to becoming a better person in general, or the idea of being part of something bigger. Every scored point is a result of many small wins on the field.`}</p>
    <p>{`A common way of distilling these worldviews into key values mentioned earlier was to simply stay vigilant for opportunities to essentially say `}<em parentName="p">{`"Hey you there, that thing you just did, that's a good thing. Do it more."`}</em></p>
    <p>{`A lot of effort also goes into purposefully recognising the athletes that didn't score the goal or make that last assist, but made that assist five moves earlier that got the ball on the right side of the court. This part is probably much harder than it sounds.`}</p>
    <p>{`The one belief they all shared was that they are responsible for helping athletes transfer skills learned in sport into real life. With the right insight into athletes' lives outside of sport, the coach can look for teachable moments and connect them to lessons from sport.`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`Fin`}</h2>
    <p>{`To sum it up, the paper says that sport can teach you good values, that it's important for your coach to make it a point to teach these values, and that women might be better at it than men.`}</p>
    <p>{`Hopefully my sister will get a good grade for her five page report on this five page paper.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=43883ca9-dacb-4159-960b-f4ddb9512349",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      